import React from 'react';
import BaseValidator from 'services/validations/base-validator';
import Const from 'constants';

class TeamNotRepeatedInOneGroupValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {legacyControlledHitterStacking} = this.dependencies;

        const firstGroupItems = legacyControlledHitterStacking.getFirstGroupItems();

        this.validateTeamInItems(firstGroupItems);

        if (this.hasErrors() || !legacyControlledHitterStacking.isDoubleStackModeEnabled()) {
            return;
        }

        const secondGroupItems = legacyControlledHitterStacking.getSecondGroupItems();

        this.validateTeamInItems(secondGroupItems);
    }

    private validateTeamInItems(items): void {
        const teamsMap = {};
        for (let item of items) {
            if (item.team in teamsMap) {
                this.addError('Team can not be repeated in one stack, please check.');
                break;
            }

            teamsMap[item.team] = true;
        }
    }
}

export default TeamNotRepeatedInOneGroupValidator;
